<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2021-01-28 09:51 -->
<template>
  <div class="card">
    <div class="card-body">
      <h5 class="text-center">TICKET {{ sale.id | number("000#####") }}</h5>
      <div v-for="(l, i) in sale.products" :key="i" class="d-flex">
        <span>
          {{ l.quantity | number("00") }} -
          {{ l.product_name }}
        </span>
        <!-- <div class="ml-auto text-nowrap"> -->
        <!--   {{ (l.unit_price * l.quantity) | money }} -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    //
  },

  // directives
  // filters

  props: {
    sale: {
      default: () => {}
    }
  },

  data: () => ({
    //
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    //
  }
};
</script>

<style scoped>
/* @import "../assets/ticket.css"; */
</style>
